import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HumanisedDate } from '../humanised-date';
import * as styles from './date-from-to.module.css';
export const DateFromTo = ({ from, to })=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            from && /*#__PURE__*/ _jsx("span", {
                id: "from",
                children: /*#__PURE__*/ _jsx(HumanisedDate, {
                    timestamp: from
                })
            }),
            from && to && /*#__PURE__*/ _jsx("span", {
                className: styles.separator,
                children: "-"
            }),
            to && /*#__PURE__*/ _jsx("span", {
                id: "to",
                children: /*#__PURE__*/ _jsx(HumanisedDate, {
                    timestamp: to
                })
            })
        ]
    });
